import styled from '@emotion/styled';

export const StyledTable = styled.div`
	width: calc(100vw - 300px);
	table {
		table-layout: auto;
	}
`;
